import { buildFaqJsonLd, serializeJsonLd } from '@/lib/structuredData';

export default function FAQJsonLd({ faqs, pageUrl, lang = 'ru' }) {
    const structuredData = buildFaqJsonLd(faqs, { pageUrl, lang });
    if (!structuredData) return null;

    return (
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
                __html: serializeJsonLd(structuredData, 2)
            }}
        />
    );
}
